module.exports = __webpack_public_path__ + "img/category-5.7e6961a0.svg";